import { toState } from "../base/redux/functions";
export function getCameraParticipantState(stateful) {
    return toState(stateful)['features/camera-participant'];
}
;
export function getCameraParticipant(stateful, participantId) {
    const { instances } = getCameraParticipantState(stateful);
    const myCameraParticipants = Array.from(instances.values());
    return myCameraParticipants.find(cp => cp.conference.myUserId() === participantId);
}
